// frontend/src/theme.js
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const baseComponents = isDark => ({
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        textTransform: 'none',
        fontWeight: 600,
        paddingTop: 8,
        paddingBottom: 8,
        boxShadow: 'none',
      },
      contained: {
        boxShadow: isDark
          ? '0 2px 8px rgba(0,0,0,0.4)'
          : '0 2px 8px rgba(25, 118, 210, 0.25)',
        '&:hover': {
          boxShadow: isDark
            ? '0 4px 12px rgba(0,0,0,0.5)'
            : '0 4px 12px rgba(25, 118, 210, 0.35)',
        },
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: isDark
          ? '0 1px 3px rgba(0,0,0,0.6)'
          : '0 1px 3px rgba(0,0,0,0.08)',
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRight: 'none',
        boxShadow: isDark
          ? '1px 0 8px rgba(0,0,0,0.4)'
          : '1px 0 8px rgba(0,0,0,0.06)',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
      rounded: {
        borderRadius: 12,
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
        boxShadow: isDark
          ? '0 2px 10px rgba(0,0,0,0.5)'
          : '0 2px 10px rgba(0,0,0,0.06)',
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        marginLeft: 8,
        marginRight: 8,
        marginBottom: 2,
        width: 'auto',
        '&.Mui-selected': {
          fontWeight: 600,
        },
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        backgroundColor: isDark ? '#263238' : '#eef4fb',
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      size: 'small',
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 6,
        fontWeight: 500,
      },
    },
  },
});

const shape = { borderRadius: 10 };

const typography = {
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  h6: { fontWeight: 700 },
  subtitle1: { fontWeight: 600 },
  button: { fontWeight: 600 },
};

export const lightTheme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: 'light',
      background: {
        default: '#f3f5f9',
        paper: '#ffffff',
      },
      primary: {
        main: '#1565c0',
        light: '#4791db',
        dark: '#0d47a1',
      },
      secondary: {
        main: '#388e3c',
      },
      divider: 'rgba(0,0,0,0.08)',
    },
    shape,
    typography,
    components: baseComponents(false),
  })
);

export const darkTheme = responsiveFontSizes(
  createTheme({
    palette: {
      mode: 'dark',
      background: {
        default: '#0f1216',
        paper: '#1a1d23',
      },
      primary: {
        main: '#90caf9',
      },
      secondary: {
        main: '#80cbc4',
      },
      divider: 'rgba(255,255,255,0.08)',
    },
    shape,
    typography,
    components: baseComponents(true),
  })
);
